<template>
  <div class="ai_modal_container" v-if="isVisible">
    <Header :title="title" :onClose="handleClose" />
    <div :class="`ai_modal_content_wrapper ${hasPadding ? 'modal_content_padding': ''}`">
      <div v-if="content" v-html="formattedContent"></div>
      <slot v-else></slot>
    </div>
  </div>
</template>

<script>
import Header from './AiHeader.vue'

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: false
    },
    onClose: {
      type: Function
    },
    hasPadding: {
      type: Boolean
    }
  },
  components: {
    Header
  },
  computed:{
    formattedContent(){
      return this.content.replace(/\n/g, '<br>');
    }
  },
  methods: {
    handleClose () {
      if (this.onClose) {
        this.onClose()
      }
    },
  }
}
</script>

<style scope>
.ai_modal_container {
  position: fixed;
  top: 0;
  width: 100%;
  max-width: 768px;
  height: 100dvh;
  margin: 0 auto;
  z-index: var(--zIndex-modal);
  background-color: var(--gray-scale-12);
  overflow: auto;
}
.modal_content_padding {
  padding: 20px
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiModal.vue